import { IAlarmSituation, TCreateAlarmSituationDTO } from './alarmSituations.types.ts'

const isCorrectFormAlarmSituationFields = (alarmSituation: IAlarmSituation | TCreateAlarmSituationDTO) => {
  return alarmSituation.name !== '' && alarmSituation.level !== null && alarmSituation.comment !== ''
}

const isNumber = (char: string) => /\d/.test(char)

const isValidSequence = (text: string): boolean => {
  const chars = text.split('')
  return chars.every((char, i, arr) => {
    const prevChar = arr[i - 1] || ''
    const prevPrevChar = arr[i - 2] || ''

    if (char === '.') return isNumber(prevChar)
    if (prevChar === '.') return isNumber(char)
    if ((char === '&' || char === '|') && prevPrevChar === char && prevChar === char) return false
    if ((prevChar === '&' && char !== '&') || (prevChar === '|' && char !== '|')) return false

    return true
  })
}

const saveCaretPosition = (container: HTMLDivElement): number | null => {
  const selection = window.getSelection()
  if (!selection || selection.rangeCount === 0) return null

  const range = selection.getRangeAt(0)
  const preCaretRange = range.cloneRange()
  preCaretRange.selectNodeContents(container)
  preCaretRange.setEnd(range.endContainer, range.endOffset)

  return preCaretRange.toString().length
}

const restoreCaretPosition = (container: HTMLDivElement, position: number) => {
  const selection = window.getSelection()
  if (!selection) return

  const range = document.createRange()
  let charCount = 0

  const traverseNodes = (node: Node): boolean => {
    if (node.nodeType === Node.TEXT_NODE) {
      const nextCharCount = charCount + node.textContent!.length
      if (charCount <= position && position <= nextCharCount) {
        range.setStart(node, position - charCount)
        range.setEnd(node, position - charCount)
        return true
      }
      charCount = nextCharCount
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      for (const child of node.childNodes) {
        if (traverseNodes(child)) return true
      }
    }
    return false
  }

  traverseNodes(container)
  selection.removeAllRanges()
  selection.addRange(range)
}

const splitFormulaTokens = (input: string) => {
  return input.split(/([><=&|!()+\-*/]+)/).filter((token) => token.trim() !== '')
}

const alarmSituationUtils = {
  isCorrectFormAlarmSituationFields,
  isValidSequence,
  saveCaretPosition,
  restoreCaretPosition,
  splitFormulaTokens,
}

export default alarmSituationUtils
